import React, { useState, useEffect } from "react";
import { Route, Redirect } from "react-router-dom";
import { decode as tokenDecoder } from "../utils/tokenDecoder";



// Shecancode Admin route
export const PrivateRoute = ({ component: Component, ...rest }) => {
  const token = localStorage.getItem("x-auth-token");
  const tokenData = tokenDecoder(token);
  return (
    <Route
      {...rest}
      render={(props) =>
        tokenData && tokenData.role === "admin" ? (
          <Component {...props} />
        ) : tokenData && tokenData.role === "student" ? (
          <Redirect to="/home" />
        ) : (
          <Redirect to="/auth/login" />
        )
      }
    />
  );
};

// Shecancode Students/Admin route
export const ProtectedRoute = ({ component: Component, ...rest }) => {
  const token = localStorage.getItem("x-auth-token");
  return (
    <Route
      {...rest}
      render={(props) =>
        token ? <Component {...props} /> : <Redirect to="/auth/login" />
      }
    />
  );
};

// Non-shecancode users route
export const PublicRoute = ({ component: Component, ...rest }) => {
  const token = localStorage.getItem("x-auth-token");
  const tokenData = tokenDecoder(token);
  return (
    <Route
      {...rest}
      render={(props) =>
        !tokenData ? (
          <Component {...props} />
        ) :  (
          <Redirect to="/home" />
        ) 
      }
    />
  );
};